// Avatar character options
export const AVATARS = [
  {
    id: 'avatar_1',
    emoji: '🐱',
    name: 'Cat',
    color: '#FFB6C1',
  },
  {
    id: 'avatar_2',
    emoji: '🐶',
    name: 'Dog',
    color: '#DEB887',
  },
  {
    id: 'avatar_3',
    emoji: '🐼',
    name: 'Panda',
    color: '#E8E8E8',
  },
  {
    id: 'avatar_4',
    emoji: '🦊',
    name: 'Fox',
    color: '#FF8C00',
  },
  {
    id: 'avatar_5',
    emoji: '🐸',
    name: 'Frog',
    color: '#90EE90',
  },
  {
    id: 'avatar_6',
    emoji: '🦁',
    name: 'Lion',
    color: '#F4A460',
  },
  {
    id: 'avatar_7',
    emoji: '🐻',
    name: 'Bear',
    color: '#8B4513',
  },
  {
    id: 'avatar_8',
    emoji: '🐰',
    name: 'Rabbit',
    color: '#FFF0F5',
  },
  {
    id: 'avatar_9',
    emoji: '🦉',
    name: 'Owl',
    color: '#D2B48C',
  },
  {
    id: 'avatar_10',
    emoji: '🐧',
    name: 'Penguin',
    color: '#87CEEB',
  },
];

// Get a random avatar
export const getRandomAvatar = () => {
  const randomIndex = Math.floor(Math.random() * AVATARS.length);
  return AVATARS[randomIndex];
};

// Get avatar by ID
export const getAvatarById = (id) => {
  return AVATARS.find(avatar => avatar.id === id) || AVATARS[0];
};

// Default avatar (Cat)
export const DEFAULT_AVATAR = AVATARS[0];
